import React from 'react';
import { usePage } from '@inertiajs/react';
import { useTrans } from '../../hooks/useTrans';
import AuthPanel from '../../components/layout/auth/AuthPanel';

export default function ErrorPage({ status }) {
    const translate = useTrans();
    const { auth } = usePage().props;

    const title = {
        500: translate('Serverfout'),
        404: translate('Foutmelding'),
        403: translate('Geen toegang'),
    }[status] || translate('Foutmelding');

    const description = {
        500: translate('Er is een fout opgetreden bij het verwerken van je verzoek.'),
        404: translate('De pagina die u zocht kon niet gevonden worden.'),
        403: translate('U heeft geen toegang tot dit onderdeel.'),
    }[status] || translate('Er is een fout opgetreden.');

    if (!auth) {
        return (
            <AuthPanel>
                <h5 className="text-lg font-bold text-[#003545]">{title}</h5>
                <hr className="my-4 border-[#dfdfdf]" />
                <p className="text-sm text-[#003545]">{description}</p>
            </AuthPanel>
        );
    }

    return (
        <div className="max-w-[1200px] mx-auto px-4">
            <div className="rounded-[3px] border border-[#bbb] bg-white">
                <div className="p-[30px]">
                    <h3 className="text-2xl font-bold text-[#003545]">{title}</h3>
                </div>
                <div className="border-t border-[#bbb] px-[30px] py-4">
                    <p className="text-sm text-[#003545]">{description}</p>
                </div>
            </div>
        </div>
    );
}
